//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamTraProUdalostDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-09-14                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(ginsevn) GID:(Web.Set.Des.Ts) V1:(evn_por_cislo,log_por_cislo,iud_por_od,iud_por_do,dat_evn,ktg_evn,typ_evn,res_evn,proces_id,proces_txt,typ_subj,sxs_subj,tab_name,proces_src,klas_evn,ixs_aus,priz_zobr,zmenu_prov) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamTraProUdalostDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamTraProUdalostDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - evn_por_cislo */
        public evn_por_cislo: number;
        public ktg_evn: number;

        /** isl view gridu */
        view: any; /*Gordic.Isl.View<Gordic.AdmIsl.Interface.GTraProUdalostListDto>*/;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamTraProUdalostDesigner>, evn_por_cislo: number, ktg_evn: number ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, evn_por_cislo, ktg_evn);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, { filterViewMode: FilterViewMode.Normal, favorites: "all" });

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamTraProUdalostDesigner>, evn_por_cislo: number, ktg_evn: number ): Forms.Form {
            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);
            v_filterForm.addSection({ label: "jres:33000129" }).addRow("jres:29930955").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), { //RC 33000129 : Zdroj ud�lost�
                model: "model.ixs_su=value.ixs_su",
                name: "ixs_su",
            })
            .addRow("jres:29802620").addField("gselectbox", Gordic.Prefabs.Select.ginsorj(), {
                model: "model.ixs_orj=value.ixs_orj",
                name: "ixs_orj"
            })
            .addRow("jres:33000005").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {
                model: "model.faze=value.faze",
                name: "faze"
            })
            .addRow("jres:29929931").addField("gselectbox", Gordic.Prefabs.Select.ginsins(), {
                model: "model.ixs_ins=value.ixs_ins",
                name: "ixs_ins"
            })
            .addRow("jres:33000130").addField("gselectbox", Gordic.Prefabs.Select.ginssta(), { //RC 33000130 : Stanice
                model: "model.ip_adr=value.ip_adr",
                name: "ip_adr"
            })
                .addRow("jres:33000131").addField("gstringbox", { name: "login_uziv" }) //RC 33000131 : GINIS login
                .addRow("jres:33000132").addField("gstringbox", { name: "login_win"}) //RC 33000132 : Windows login
            .addSection({ label: "jres:33000128" }).addRow({ label: "jres:29924370" }).addField("gselectbox", Gordic.Prefabs.Select.gincevn(), { //RC 33000128 : Parametry ud�lost�
                model: "model.ktg_evn=value.ktg_evn",
                name: "ktg_evn",
                multi: true,
                //validators: [new Gordic.Validators.Required({ stopping: true })]
            }).addRow({ label: "jres:33000127" }).addField("gdatebox", "w-6", { //RC 33000127 : Datum ud�losti od - do
                name: "dat_evn_from"
            }).addField("gdatebox", "w-6", {
                name: "dat_evn_to"
            })
            .addRow("jres:33000133").addField("gstringbox", { //RC 33000133 : Parametry
                name: "var_name_txt",
            })
            .addRow("jres:33000134").addField("gstringbox", { //RC 33000134 : Data
                name: "var_value_txt"
            }) 
            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamTraProUdalostDesigner>, ev, ctx): any {
            var filterObj = {
                ktg_evn: SeznamBase.filterContains(ctx.filter, "ktg_evn"),
                dat_evn_from: SeznamBase.filterContains(ctx.filter, "dat_evn_from"),
                dat_evn_to: SeznamBase.filterContains(ctx.filter, "dat_evn_to"),
                ixs_su: SeznamBase.filterContains(ctx.filter, "ixs_su"),
                ixs_orj: SeznamBase.filterContains(ctx.filter, "ixs_orj"),
                faze: SeznamBase.filterContains(ctx.filter, "faze"),
                ixs_ins: SeznamBase.filterContains(ctx.filter, "ixs_ins"),
                ip_adr: SeznamBase.filterContains(ctx.filter, "ip_adr"),
                login_uziv: SeznamBase.filterContains(ctx.filter, "login_uziv"),
                login_win: SeznamBase.filterContains(ctx.filter, "login_win"),
                var_name_txt: SeznamBase.filterContains(ctx.filter, "var_name_txt"),
                var_value_txt: SeznamBase.filterContains(ctx.filter, "var_value_txt"),
            }
            that.view = new Gordic.Isl.View(that.isl.TraProUdalost.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamTraProUdalostDesignerInit
         * 
         * @param {GContentType<SeznamTraProUdalostDesigner>} that
         */
        static SeznamTraProUdalostDesignerInit(that: GContentType<SeznamTraProUdalostDesigner>, evn_por_cislo: number, ktg_evn: number) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, evn_por_cislo, ktg_evn);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
        }
    }
}
